import L from "leaflet";
import GlobalUtils from "@/utils/GlobalUtils";
import { ICON_TYPE, svgIcon } from "./SvgIcon";

interface InfraBeacon {
  id: number | string;
  trackerIcon?: string;
  name?: string;
  serial?: string;
}

const InfraMarkerIcon = (beacon: InfraBeacon): L.Icon => {
  return svgIcon({
    iconUrl: beacon.trackerIcon
      ? GlobalUtils.getFile(
          "device",
          beacon.id,
          "icon",
          beacon.trackerIcon,
          "small"
        )
      : "/images/beacon/icons/default_icon.svg",
    id: beacon.id?.toString(),
    state: beacon.name || beacon.serial,
    iconAnchor: infraIconAnchor(),
    network: false,
    type: ICON_TYPE.infraType,
  });
};

export default InfraMarkerIcon;

const infraIconAnchor = (): [number, number] => {
  return [15, 31];
};

const infraIconTooltipOffset = (): [number, number] => {
  return [0, -26];
};

export { infraIconAnchor, infraIconTooltipOffset };